'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--XingWithCircle';

var EntypoXingWithCircle = function EntypoXingWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M8.063,11.5c0,0-0.086,0.172-0.153,0.309C7.839,11.947,7.674,12,7.563,12H6.149c-0.25,0-0.239-0.191-0.178-0.316C6.034,11.559,6.063,11.5,6.063,11.5l1.125-2.25L6.563,8c0,0-0.029-0.06-0.092-0.185C6.41,7.69,6.399,7.5,6.649,7.5h1.414c0.111,0,0.276,0.053,0.347,0.19C8.477,7.828,8.563,8,8.563,8l0.625,1.25L8.063,11.5z M14.03,5.815C13.967,5.94,13.938,6,13.938,6l-2.5,5l1.5,3c0,0,0.029,0.059,0.092,0.184c0.062,0.125,0.072,0.316-0.178,0.316h-1.414c-0.112,0-0.275-0.053-0.345-0.191C11.024,14.171,10.938,14,10.938,14l-1.5-3l2.5-5c0,0,0.086-0.172,0.155-0.31c0.069-0.138,0.232-0.19,0.345-0.19h1.414C14.102,5.5,14.091,5.69,14.03,5.815z' })
    );
};

exports.default = EntypoXingWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/XingWithCircle.js
// module id = ./node_modules/react-entypo/lib/entypo/XingWithCircle.js
// module chunks = 2